import script from "./searchAndResetButton.vue?vue&type=script&setup=true&lang=js"
export * from "./searchAndResetButton.vue?vue&type=script&setup=true&lang=js"

import "./searchAndResetButton.vue?vue&type=style&index=0&id=25d8773a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25d8773a"]])

export default __exports__